import React from "react";
import { StreamingAvatarStore } from "@/features/avatar/store/StreamingAvatarStore";

export const StreamingAvatarStoreContext =
    React.createContext<StreamingAvatarStore | null>(null);

export const StreamingAvatarStoreProvider: React.FC<{
    children: React.ReactNode;
}> = ({ children }) => {
    const store = React.useRef(
        new StreamingAvatarStore(
            process.env.NEXT_PUBLIC_BASE_API_URL || "https://api.heygen.com",
        ),
    ).current;
    return (
        <StreamingAvatarStoreContext.Provider value={store}>
            {children}
        </StreamingAvatarStoreContext.Provider>
    );
};
